'use client';
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { ModelProvider } from '@/context/ModelContext';
import { ThemeProvider } from '@/context/ThemeContext';
import { Toaster } from 'sonner';

interface AppLayoutProps {
  children: React.ReactNode;
  activeRoute: string;
}

export default function AppLayout({ children, activeRoute }: AppLayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <ThemeProvider>
      <ModelProvider>
        <div className="flex h-screen overflow-hidden bg-background">
          {/* Desktop Sidebar */}
          <div className="hidden lg:flex">
            <Sidebar
              collapsed={sidebarCollapsed}
              onToggleCollapse={() => setSidebarCollapsed((prev) => !prev)}
              activeRoute={activeRoute}
            />
          </div>

          {/* Mobile Sidebar Overlay */}
          {mobileSidebarOpen && (
            <div className="fixed inset-0 z-50 lg:hidden">
              <div
                className="absolute inset-0 bg-black/70 backdrop-blur-sm"
                onClick={() => setMobileSidebarOpen(false)}
              />
              <div className="relative z-10 h-full">
                <Sidebar
                  collapsed={false}
                  onToggleCollapse={() => setMobileSidebarOpen(false)}
                  activeRoute={activeRoute}
                  isMobileDrawer
                  onClose={() => setMobileSidebarOpen(false)}
                />
              </div>
            </div>
          )}

          {/* Main content */}
          <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
            <Topbar onMobileMenuToggle={() => setMobileSidebarOpen((prev) => !prev)} />
            <main className="flex-1 overflow-y-auto scrollbar-thin">
              <div className="max-w-screen-2xl mx-auto px-4 lg:px-6 xl:px-8 2xl:px-10 py-6">
                {children}
              </div>
            </main>
          </div>
        </div>
        <Toaster position="bottom-right" richColors closeButton />
      </ModelProvider>
    </ThemeProvider>
  );
}
